import { LANE_INDEXES, cellId } from '@cards/engine';
import { defineGameCard, onResolve, tableTarget } from '../authoring/index.js';
import { plannedTableId, residueStacks, slimeDependencies } from './slime-helpers.js';
export const ContaminationMapCard = defineGameCard({
    id: 'contamination_map',
    gameplay: {
        type: 'SPELL', cost: 2,
        planning: { target: tableTarget({ cardinality: { min: 1, max: 1 } }) },
    },
    presentation: {
        name: 'Карта загрязнения',
        description: 'Возьмите по 1 карте за каждую ячейку вашей стороны со Склизью в выбранной локации, максимум 3 карты.',
        glyph: {
            colors: ['#10213A', '#453126', '#70472B', '#241C20', '#241C20'],
            rows: [
                '....................',
                '....................',
                '...............111..',
                '..............12221.',
                '.............1234241',
                '......11111..142241.',
                '....11222221..1411..',
                '...1422222221..1....',
                '...12223322241......',
                '..1223322442221.....',
                '..1222222222441.....',
                '...14422232411......',
                '....11444441........',
                '......14411..1111...',
                '.......11...142221..',
                '............123321..',
                '...........14222241.',
                '............142241..',
                '.............1111...',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeDependencies(),
    abilities: [onResolve((ctx) => {
            const self = ctx.self;
            const tableId = plannedTableId(ctx, 'target');
            if (self === undefined || tableId === undefined)
                return;
            const side = ctx.q.player(self.controllerId).side;
            const count = LANE_INDEXES.filter((laneIndex) => residueStacks(ctx, cellId(tableId, laneIndex, side)) >= 1).length;
            if (count > 0)
                ctx.ops.drawCard(self.controllerId, count);
        })],
    ui: {
        mechanics: ['slime_residue'],
        planning: { steps: { target: { label: 'Выберите локацию' } } },
    },
});
//# sourceMappingURL=contamination_map.js.map